import Button from "@/wmCompoments/button";
import Input from "@/wmCompoments/input";
import classNames from "classnames";
import React, { useMemo, useState } from "react";
import styles from './accountSecurity.module.scss'
import Icon from "@/wmCompoments/Icon";
import { useSendCode, useUserInfo } from "@/api/request";
import { useBindUserEmail, useBindUserPhone } from "./api";
import CodeDialog from "@/antComponent/codeDialog";
import useSmsCountDown from "@/commonHooks/useSmsCountDown";
import InputPhone from "@/compoments/inputPhone";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";


const ButtonSendCode = ({ loading, onClick, secounds }) => {
    const { t } = useTranslation('personalInfo')
    return <Button
        loading={loading}
        disabled={!!secounds}
        onClick={onClick} type="green" className={styles.sendCode}>
        {
            !!secounds ? <span>{`${secounds}s`}</span> : <span className={styles.sendText}>{t('bind')}</span>
        }
    </Button>
}

const AccountSecurity = () => {
    const { t } = useTranslation('personalInfo')

    const { data, mutate } = useUserInfo()

    const { secounds, start } = useSmsCountDown('smsCode')
    const [phoneValue, setPhoneValue] = useState<any>({})
    const [emailValue, setEmailValue] = useState('')
    const [dialogInfo, setDialogInfo] = useState({
        visible: false,
        type: '',
        text: ''
    })

    const { trigger: triggerPhone, isMutating: mutatingPhone } = useBindUserPhone()
    const { trigger: triggerEmail, isMutating: mutatingEmail } = useBindUserEmail()
    const { trigger: triggerCode, isMutating: mutatingCode } = useSendCode()

    const phoneInfo = useMemo(() => {
        const isBind = !!data?.phone
        return {
            isBind,
            text: isBind ? t('bound') : t('unbound')
        }
    }, [data])

    const emailInfo = useMemo(() => {
        const isBind = !!data?.email
        return {
            isBind,
            text: isBind ? t('bound') : t('unbound')
        }
    }, [data])

    const onClickBindPhone = async (code) => {
        const { areaCode, regex } = phoneValue?.area || {}
        const { value } = phoneValue || {}
        if (!value) {
            return Toast.show(t('enterPhone'))
        }
        if (!areaCode) {
            return Toast.show(t('noValidCountryCode'))
        }
        const _regex = new RegExp(regex)
        const isPhoneValid = _regex.test(areaCode + value)
        if (!isPhoneValid) {
            return Toast.show(t('enterValidPhone'))
        }

        const phone = areaCode + value
        try {
            if (!code) {
                await triggerCode({
                    cate: '0',
                    sendCodeNum: phone?.replace?.('+', '') ?? '',
                    type: '0'
                })
                start()
                setDialogInfo({
                    visible: true,
                    type: 'phone',
                    text: phone
                })
            } else {
                await triggerPhone({
                    areaCode,
                    code,
                    phone
                })
                await mutate()
            }
        } catch (error: any) {
            Toast.show(error?.message || JSON.stringify(error))
        }
    }

    const onClickBindEmail = async (code) => {
        if (!emailValue || !emailValue?.includes('@')) {
            Toast.show(t('enterValidEmail'))
            return
        }
        try {
            if (!code) {
                await triggerCode({
                    cate: '1',
                    type: '1',
                    sendCodeNum: emailValue
                })
                start()
                setDialogInfo({
                    visible: true,
                    type: 'email',
                    text: emailValue
                })
            } else {
                await triggerEmail({
                    code,
                    email: emailValue
                })
                await mutate()
            }
        } catch (error: any) {
            Toast.show(error?.message || JSON.stringify(error))
        }
    }


    return <div>
        <div className={styles.title}>{t('accountSecurity')}</div>

        <div className={classNames(styles.inputWarpper)}>
            {
                phoneInfo.isBind ? <Input
                    suffix={
                        <span className={classNames({
                            [styles.bindColor]: phoneInfo.isBind
                        })}>{phoneInfo.text}</span>
                    }
                    readOnly={phoneInfo?.isBind}
                    hidePlaceholder={true}
                    onChange={(v) => {
                        setPhoneValue(v)
                    }}
                    value={phoneInfo?.isBind ? data?.phone : phoneValue}
                    prefix={
                        <Icon name={'icon-user-mobile'} className={classNames({
                            [styles.bindColor]: phoneInfo.isBind
                        }, styles.prefixIcon
                        )}


                        />}
                    className={styles.wrapClassName}
                /> :
                    <InputPhone
                        wrapPrefix={
                            <Icon name={'icon-user-mobile'} className={classNames({
                                [styles.bindColor]: phoneInfo.isBind
                            }, styles.prefixIcon
                            )} />
                        }
                        wrapClassName={classNames(styles.wrapClassName, styles.wrapClassPhone)} placeholder={t('bindPhone')} suffix={
                            <span className={classNames({
                                [styles.bindColor]: phoneInfo.isBind
                            })}>{phoneInfo.text}</span>
                        }
                        value={phoneInfo?.isBind ? data?.phone : phoneValue}
                        readOnly={phoneInfo?.isBind}
                        hidePlaceholder={true}
                        onChange={(v) => {
                            setPhoneValue(v)
                        }}
                    />
            }

            {!phoneInfo.isBind && <ButtonSendCode loading={mutatingCode} onClick={() => {
                if (!!secounds) {
                    return
                }
                onClickBindPhone('')
            }}
                secounds={secounds}
            />}
        </div>


        <div className={classNames(styles.inputWarpper)}>
            <Input
                prefix={
                    <Icon name={'icon-user-email'} className={classNames({
                        [styles.bindColor]: emailInfo.isBind
                    }, styles.prefixIcon
                    )} />
                }
                className={classNames(styles.wrapClassName)} placeholder={t('bindEmail')} suffix={
                    <span className={classNames({
                        [styles.bindColor]: emailInfo.isBind
                    })}>{emailInfo.text}</span>
                }
                value={emailInfo?.isBind ? data?.email : emailValue}
                readOnly={emailInfo?.isBind}
                hidePlaceholder={true}
                onChange={(v) => {
                    setEmailValue(v)
                }}
            />
            {!emailInfo.isBind &&
                <ButtonSendCode loading={mutatingCode} onClick={() => {
                    if (!!secounds) {
                        return
                    }
                    onClickBindEmail('')
                }}
                    secounds={secounds}
                />
            }
        </div>

        <CodeDialog visible={dialogInfo.visible} text={dialogInfo.text} onSubmit={(v) => {
            return dialogInfo.type === 'email' ? onClickBindEmail(v) : onClickBindPhone(v)
        }} onClose={() => {
            setDialogInfo({
                ...dialogInfo,
                visible: false
            })
        }} />
    </div>
}
export default AccountSecurity